import { Component } from '@angular/core';

@Component({
    selector: 'error-forbidden',
    templateUrl: './forbidden.component.html',
    styles: []
})
export class ForbiddenComponent {
    constructor() { }
}